import React from 'react'
import {
    StyledProfileCard,
    StyledCardTextContainer,
    StyledCardText,
    StyledLink,
    StyledPremiumIcon,
} from './ProfileCard.styled'
import { MaybeLoaded } from 'json-react-layouts-data-loader'
import { CommonCardProps } from '../CardItem.Props'

import { toLinkWithHint } from 'common/routing/route-hints'
import { CardMedia } from '../CardMedia/CardMedia'
import { PublicationCardItem } from 'common/client-data-types/card-types'
import { createCardClickedEvent } from 'common/events/collection-events'

export interface Props extends CommonCardProps {
    cardNumber: number
    innerRef?: React.RefObject<any>
    item: MaybeLoaded<PublicationCardItem>
}

export const ProfileCard: React.FC<Props> = props => {
    const linkClicked = (e: React.MouseEvent<HTMLElement>) => {
        if (!props.item.loaded) {
            // We don't want the link to do anything
            e.preventDefault()
            return
        }

        props.onEvent(
            createCardClickedEvent(
                props.item.result,
                'InternalProfileCard',
                'ProfileCard',
                props.cardNumber
            )
        )
    }

    const { item, onEvent } = props
    return (
        <StyledProfileCard>
            <StyledLink to={toLinkWithHint(item)} onClick={linkClicked}>
                {item.loaded && item.result.isPremium && <StyledPremiumIcon />}
                <CardMedia item={item} onEvent={onEvent} mediaMode={'edgeToEdge'} />
                <StyledCardTextContainer>
                    <StyledCardText
                        fontScale={1}
                        item={item}
                        onEvent={onEvent}
                        hideTeaser={true}
                        hidePremiumIcon={true}
                        hideVideoIcon={true}
                    />
                </StyledCardTextContainer>
            </StyledLink>
        </StyledProfileCard>
    )
}
